<template>
  <div class="z-90">
  <div class="rounded-lg shadow-lg bg-black max-w-lg">
    <div class="foto">
      <img class="rounded-t-lg" :src="url" alt=""/>     
    </div>
    <div class="name">
       <h5 class="text-white-900 text-xl font-medium mb-2">{{ characterName }}</h5>
      <p class="text-gray-700 text-base mb-4">
        {{ description }}
      </p>
      <p class="text-gray-700 text-base mb-4" v-if="error_m">
       Error 401. No have comunication with the Professor Xavier
      </p>
    </div>       
   
    <div class="p-6">
      
      <comics class="comics" :name="heroe"/>
     
      
      <button type="button" class="bg-transparent hover:bg-red-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded" @click="closeCard(heroe)">
      <img class="close" src="../assets/x.png" alt=""/>
      Close</button>
    </div>
  </div>
</div>
  
</template>
<script>
// import { public_key , secret_key } from '../marvel'
import Comics from './Comics.vue';
import { public_key } from "../marvel";
import axios from "axios";

export default {
  name: "Fichatecnica",
  components: { Comics},
  props: ['name', 'error_message'],
  data() {
    return {
      character:{},
      display: true,
      heroe:this.name,
      url:"",
      size:"standard_large.jpg",
      description: "",
      id:"",
      characterName:"",
      error_m: this.error_message,
    }
  },
  
  created() {
    this.getCharacterforId()
  },
  computed:{
   

  },
  mounted() {
     
    //  this.getImage()
  },
 
  methods: {
    async getCharacterforId() {
    
           let id= this.heroe
            // let name = this.state.name
            // console.log(name);
             await axios
              .get(
                `https://gateway.marvel.com/v1/public/characters/${id}?apikey=${public_key}`
              )
              .then((result) => {
                
                this.character = result.data.data.results
                this.characterName = this.character[0].name
                console.log(this.character[0].name);
                this.url = this.character[0].thumbnail.path + "/" + this.size
                console.log(this.url)
                this.description = this.character[0].description
                this.id = this.character[0].id
                console.log(this.id)
              })
              .catch((error) => {
                console.log(error);
              });
        
              
          },
          closeCard(data) {
           console.log(data)
           this.$emit('close',data)
            // this.display = true;
          },
          getImage(){
            this.url = this.character
            console.log(this.url)
          }
  },
};
</script>
<style>
.foto { grid-area: foto; }
.name { 
  grid-area: name; 
  font-family: 'Rubik Dirt', cursive;
  color: white;
  }
.comics {
  display: grid; 
  grid-template-columns: 1fr 1fr 1fr; 
  grid-template-rows: 1fr 1fr 1fr; 
  gap: 0px 0px; 
  grid-template-areas: 
    "foto1 foto2 foto3"
    "foto1 foto2 foto3"
    "foto1 foto2 foto3"; 
  grid-area: comics; 
}
.close{ 
  width:10%;
  height:10%
}
</style>